/* eslint-disable no-undef */
import React, { useEffect, useRef, useState } from 'react'
import './modalpopup.css' // Create this CSS file for styling
import { RhyBusButton } from '@rhybus/button'
interface PopupProps {
  isOpen?: boolean;
  popupheaderclass?: string;
  popupbodyclass?: string;
  popupfooterclass?: string;
  popupcontentclass?: string;
  onClose?: () => void;
  headerContent?: React.ReactNode;
  bodyContent?: React.ReactNode;
  footerContent?: React.ReactNode;
  className?: string;
  children?: any
  onClick?: any
  isClose?: any
  isButton?: any
  btn1onClick?: any
  btn2onClick?: any
  popupclass?: any
}

const Modalpopupheader: React.FC<PopupProps> = ({ children, className }) => (
  <div data-popup-header="true" className={`modal-header ${className}`}>
    {children}
  </div>
)

const Modalpopupbody: React.FC<PopupProps> = ({ className, children }) => {
  return (
    <div className={`modalpopupbody ${className}`}>
      {children}
    </div>
  )
}

const Modalpopupfooter: React.FC<PopupProps> = ({ className, children }) => (
  <div data-popup-footer="true" className={`modal-footer ${className}`}>
    {children}
  </div>
)

const Modalpopup: React.FC<PopupProps> = ({ isOpen, headerContent, bodyContent, footerContent, popupheaderclass, popupbodyclass, popupfooterclass, popupcontentclass, onClick, isClose, isButton, btn1onClick, btn2onClick, popupclass }) => {
  const [popupheaderHeight, setPopupHeaderHeight] = useState<number>(0)
  const [popupfooterHeight, setPopupFooterHeight] = useState<number>(0)
  const [popupBodyHeight, setPopupBodyHeight] = useState<number>(0)
  function handleWindowResize() {
    const popupHeaderElement = document.querySelector('[data-popup-header="true"]')
    const popupFooterElement = document.querySelector('[data-popup-footer="true"]')
    if (popupHeaderElement instanceof HTMLElement) {
      const height = popupHeaderElement.offsetHeight
      setPopupHeaderHeight(height)
    }
    if (popupFooterElement instanceof HTMLElement) {
      const height = popupFooterElement.offsetHeight
      if (height)
        setPopupFooterHeight(height)
      else
        setPopupFooterHeight(0)
    }
  }
  window.addEventListener('resize', handleWindowResize)

  useEffect(() => {
    // Get header height based on attribute or tag
    handleWindowResize()
  }, [])
  useEffect(() => {
    // Get header height based on attribute or tag
    setPopupBodyHeight(popupheaderHeight + popupfooterHeight)
  }, [popupheaderHeight, popupfooterHeight])

  useEffect(() => {
    // Update CSS variable when headerFooterHeight changes
    document.documentElement.style.setProperty('--popup-body-height', `${popupBodyHeight}px`)
  }, [popupBodyHeight])

  // const handleOverlayClick = () => {
  //   onClose();
  // };

  const popupBodyRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (isOpen && popupBodyRef.current) {
      const focusableElements = popupBodyRef.current.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      if (focusableElements.length > 0) {
        (focusableElements[0] as HTMLElement).focus()
      }
    }
  }, [isOpen])

  if (!isOpen) return null
  return (
    <div className={`popup-container ${popupclass || ''} ${isOpen ? 'open' : ''}`}>
      <div className={`popup-content bgcolor-transparent ${popupcontentclass || ''}`}>
        <div className='card white-bg shadow-5' ref={popupBodyRef}>
          {headerContent && <Modalpopupheader className={`d-flex align-items-center ${popupheaderclass ?? ''}`}>{headerContent}{isClose && <button type="button" className='btn icon-rb-close ms-auto font-13' onClick={onClick}></button>}</Modalpopupheader>}
          {bodyContent && <Modalpopupbody className={popupbodyclass ?? ''}>{bodyContent}</Modalpopupbody>}
          {footerContent && <Modalpopupfooter className={popupfooterclass ?? ''}>{footerContent}</Modalpopupfooter>}
          {isButton && <div className="d-flex gap-2 p-3 justify-content-end">
            <RhyBusButton
              label={'OK'}
              className={'btn-md btn-primary font-13 poppins-semibold whitetext btn-border-radius'}
              leftIcon={'icon-rb-checked pe-1'}
              onClick={btn1onClick}
              type="button" />
            <RhyBusButton
              label={'CANCEL'}
              className={'btn-md font-13 poppins-semibold btn-border-radius btn-border-1'}
              leftIcon={'icon-rb-close pe-1'}
              onClick={btn2onClick}
              type="button" />
          </div>}
        </div>
      </div>
      {/* <div className="overlay" onClick={handleOverlayClick}></div> */}
      <div className="overlay"></div>
    </div>
  )
}

export default Modalpopup
